import React from 'react';
import {
    FormattedMessage,
    WrappedComponentProps,
    injectIntl,
} from 'react-intl';
import { IOrder, IPromoDetail } from '../../../models/talend';

interface ICertificate {
    promotionName: string;
    description: string;
    orderNumber: number;
    commitmentQuantity: number;
    futureQuantity: number;
    orderedQuantity: number;
    receivedQuantity: number;
    remainingQuantity: number;
    applicableFor: string;
    nextReleaseDate?: Date;
    nextReleaseCount: number;
    releaseEarly: boolean;
}

const getDays = (a: Date, b: Date): number => {
    const diff = Math.abs(a.getTime() - b.getTime());

    return Math.ceil(diff / (1000 * 3600 * 24));
};

const getCertificate = (promoDetail: IPromoDetail): ICertificate => {
    const orders: IOrder[] = promoDetail.orders;

    const curOrder = orders.find((order) => {
        return (
            order.orderOnPromoHold.toLocaleLowerCase() === 'h' &&
            new Date(order.requestDate) > new Date()
        );
    });

    const nextReleaseDate = curOrder
        ? new Date(curOrder.requestDate)
        : undefined;
    const nextReleaseCount = curOrder
        ? curOrder.items.reduce(
              (sum, current) => sum + current.orderedQuantity,
              0
          )
        : 0;

    const cert: ICertificate = {
        promotionName: promoDetail.promotionName,
        description: promoDetail.description,
        orderNumber: curOrder ? curOrder.orderNumber : 0,
        commitmentQuantity: promoDetail.commitmentQuantity,
        futureQuantity: promoDetail.futureQuantity,
        orderedQuantity: promoDetail.orderedQuantity,
        remainingQuantity: promoDetail.remainingQuantity,
        receivedQuantity:
            promoDetail.receivedQuantity - promoDetail.returnedQuantity,
        applicableFor: promoDetail ? promoDetail.products.join(',') : '',
        nextReleaseDate: nextReleaseDate,
        nextReleaseCount: nextReleaseCount,
        releaseEarly:
            nextReleaseDate && nextReleaseCount > 0
                ? getDays(nextReleaseDate, new Date()) < 30
                : false,
    };

    return cert;
};

interface ICertificateProps {
    promoDetail: IPromoDetail;
    onRelease?: (
        event: React.MouseEvent<HTMLElement>,
        orderNumber: number
    ) => void;
}

export const Certificate = ({ promoDetail, onRelease }: ICertificateProps) => {
    const cert = getCertificate(promoDetail);
    // const dateOpts = {
    //     weekday: 'long',
    //     year: 'numeric',
    //     month: 'long',
    //     day: 'numeric'
    // };

    // let hoverUsed =
    //     intl.formatMessage({ id: 'Certificates_Used' }) +
    //     ': ' +
    //     cert.receivedQuantity;
    // let hoverRemaining =
    //     intl.formatMessage({ id: 'Certificates_Available' }) +
    //     ': ' +
    //     cert.remainingQuantity;
    // let hoverNextRelease = cert.nextReleaseDate
    //     ? intl.formatMessage({ id: 'Certificates_Will_Be_Released_On' }) +
    //       ': ' +
    //       cert.nextReleaseDate.toLocaleDateString('en-us', dateOpts)
    //     : '';

    return (
        <>
            <div className="panel panel-primary">
                <div className="panel-heading">
                    <h3
                        style={{
                            margin: 0,
                            border: 'none',
                        }}
                    >
                        {cert.promotionName}
                    </h3>
                </div>
                <div className="panel-body">
                    {cert.orderNumber > 0 && (
                        <div>
                            <strong>
                                <FormattedMessage id="Order_Number_2" />:
                            </strong>
                            <span> {cert.orderNumber}</span>
                        </div>
                    )}
                    <div>
                        <strong>
                            <FormattedMessage id="Applicable_For" />:
                        </strong>
                        <span> {cert.description}</span>
                    </div>
                    {/* <div className="progress">
            <div
              className="progress-bar progress-bar-success"
              id="bill-cert-prog-used"
              title={hoverUsed}
              style={{
                width: `${(cert.receivedQuantity / cert.orderedQuantity) *
                  100}%`
              }}
            />

            <div
              className="progress-bar progress-bar"
              id="bill-cert-prog-available"
              title={hoverRemaining}
              style={{
                width: `${(cert.remainingQuantity / cert.orderedQuantity) *
                  100}%`
              }}
            />
            <div
              className="progress-bar progress-bar-info"
              id="bill-cert-prog-available"
              title={hoverNextRelease}
              style={{
                width: `${(cert.nextReleaseCount / cert.orderedQuantity) *
                  100}%`
              }}
            />
          </div> */}
                    <div>
                        <strong>
                            <FormattedMessage id="Certificates" />:
                        </strong>
                        <span>
                            {' ' + cert.orderedQuantity + ' '}
                            <FormattedMessage id="of" />
                            {' ' + cert.commitmentQuantity + ' '}
                            <FormattedMessage id="used" />
                            {' (' + cert.futureQuantity + ' '}
                            <FormattedMessage id="remaining" />)
                        </span>
                    </div>
                    {cert.orderNumber > 0 && (
                        <div>
                            <strong>
                                <FormattedMessage id="Available_Now" />:
                            </strong>
                            <span> {cert.remainingQuantity}</span>
                        </div>
                    )}
                </div>
                <div className="panel-footer">
                    <div className="row">
                        <div className="col-md-10" />
                        <div className="col-md-2">
                            <button
                                type="button"
                                className="btn btn-primary"
                                onClick={(e) =>
                                    onRelease && onRelease(e, cert.orderNumber)
                                }
                                disabled={!cert.releaseEarly}
                            >
                                <FormattedMessage id="Release_Early" />
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Certificate;
